import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'variant', label: 'Variant', kind: 'select', options: ['date', 'datetime'] },
  { key: 'format', label: 'Format', kind: 'text' },
  { key: 'min', label: 'Min', kind: 'text' },
  { key: 'max', label: 'Max', kind: 'text' },
  { key: 'default_offset', label: 'Default offset', kind: 'text' },
];

export default function DateConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
